/**
 * EmptyState — the "nothing here" surface, in the three shapes the Monitoring screen
 * actually has (spec D5): a page-level empty block, an error with a retry action, and
 * the ten inline placeholders. All three are one rule group in the legacy stylesheet
 * already, so they are one export here; two extra exports with one call site each would
 * fail the two-consumer gate.
 *
 * No skill counterpart — gap-audit.md:9 names EmptyState as the design system's
 * outstanding blocker («в UX-аудите это блокер №5»), so the contract is authored here
 * from tokens.
 *
 *   tone="error"  → the copy turns to --color-error (the failure branches);
 *   compact       → the inline placeholder surface (quiet grey + hairline ring, the
 *                   DS draft-container language) instead of an airy page block;
 *   action        → a node rendered under the copy, e.g. the «Повторить» button.
 */
export function EmptyState ({ children, tone = 'neutral', compact = false, action, className, ...rest }) {
  return (
    <div
      className={[
        'oc-empty',
        tone === 'error' && 'oc-empty--error',
        compact && 'oc-empty--compact',
        className,
      ].filter(Boolean).join(' ')}
      {...rest}
    >
      <span className="oc-empty__message">{children}</span>
      {action && <span className="oc-empty__action">{action}</span>}
    </div>
  );
}
